import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useNav } from '../../Context/Navigation';
import { Footer } from '../Footer';
import { MobileMenu } from '../MobileMenu';
import { DesktopSidebar } from '../DesktopSidebar';
import { UpperNav } from '../UpperNav';
import { useImpersonationFromUrl } from '../../Hooks/useImpersonationFromUrl';
import useUser from '../../Hooks/useUser';
import { PodcastPlayer } from '../Podcast/PodcastPlayer';

export const PageLayout = () => {
  const [desktopSidebarOpen, setDesktopSidebarOpen] = useState(true);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const { currentPage, sidebarNavigation, forceCollapse } = useNav();
  const { setImpersonateEmail, handleUserViewChange } = useUser();

  // User Impersonation from Admin App
  useImpersonationFromUrl(setImpersonateEmail, handleUserViewChange);

  const sidebarWidth = desktopSidebarOpen ? 'w-108' : 'w-42';

  useEffect(() => {
    if (forceCollapse) {
      setDesktopSidebarOpen(false);
    }
  }, [forceCollapse]);

  const navigationWithCurrent = sidebarNavigation.map((item) => ({
    ...item,
    current: currentPage === item.name
  }));

  return (
    <>
      <MobileMenu
        isOpen={mobileSidebarOpen}
        setIsOpen={setMobileSidebarOpen}
        sidebarNavigation={navigationWithCurrent}
      />

      <div className="flex">
        <div className={`${sidebarWidth} hidden lg:block`}>
          <DesktopSidebar
            isOpen={desktopSidebarOpen}
            setIsOpen={setDesktopSidebarOpen}
            sidebarNavigation={navigationWithCurrent}
            currentPage={currentPage}
          />
        </div>

        <div className="relative flex min-h-[100dvh] flex-1 flex-col">
          <UpperNav setMobileSidebarOpen={setMobileSidebarOpen} />

          <main className="bg-pdteal/5 h-full pt-10 pb-[4rem]">
            <div className="sm:px-6 lg:px-8">
              <Outlet />
            </div>
          </main>

          <PodcastPlayer />
          <Footer />
        </div>
      </div>
    </>
  );
};
